// Venedor Sections
vndTheme.vndSts = function vndSts() {
  $(document)
    .on('shopify:section:load', this.onLoad)
    .on('shopify:section:unload', this.onUnload)
    .on('shopify:section:select', this.onSelect)
    .on('shopify:section:deselect', this.onDeselect)
    .on('shopify:block:select', this.onBlkSelect)
    .on('shopify:block:deselect', this.onBlkDeselect);
}

vndTheme.vndSts.prototype = {
  onLoad(evt) {
    const ts = evt.target; // Target Section

    // Header
    if ( ts.id == 'shopify-section-top-bar' ) {
      vndHlp.initSct(ts.id, null, vndTopbar.onLoad);
    }

    if ( ts.id == 'shopify-section-header' ) {
      vndHlp.initSct(ts.id, null, vndHeader.onLoad);
    }

    // Slideshow
    if ( ts.classList.contains('vs-homepage-slideshow') ) {
      vndHlp.initSct(ts.id, null, slideShow.onLoad);
    }

    // Parallax lookbook
    if ( ts.classList.contains('vs-parallax-lookbook') ) {
      vndHlp.initSct(ts.id, null, parallaxLookbook.onLoad);
    }

    // Lookbook spots
    if ( ts.classList.contains('vs-lookbook') ) {
      vndHlp.initSct(ts.id, null, lookbookSection.onLoad);
    }

    // Lookbook switcher
    if ( ts.classList.contains('vs-lookbook-2') ) {
      vndHlp.initSct(ts.id, null, lookbookSection2.onLoad);
    }

    // Product showcase
    if ( ts.classList.contains('vs-product-showcase') ) {
      vndHlp.initSct(ts.id, null, productShowCase.onLoad);
    }

    // Sections with sidebar
    if ( ts.classList.contains('vs-group-content') ) {
      vndHlp.initSct(ts.id, null, groupContent.onLoad);
    }

    //Items carousel section
    if ( ts.classList.contains('vs-initialize-slider') ) {
      vndHlp.initSct(ts.id, null, vndSectionSlider.onLoad);
    }

    // Collections tab section
    if ( ts.classList.contains('vs-collections-tab') ) {
      vndHlp.initSct(ts.id, null, vndIstSection.onLoad);
    }

    // Instagram section
    if ( ts.classList.contains('vs-instagram') ) {
      vndHlp.initSct(ts.id, null, vndInstaSt.onLoad);
    }

    // Map section
    if ( ts.classList.contains('vs-google-map') ) {
      vndHlp.initSct(ts.id, null, mapSection.onLoad);
    }

    // Products Masonry
    if ( ts.classList.contains('vs-products-masonry') ) {
      vndHlp.initSct(ts.id, null, productsMasonry.onLoad);
    }

    // Text with media packery
    if ( ts.classList.contains('vs-packery') ) {
      vndHlp.initSct(ts.id, null, vndPkrSt.onLoad);
    }

    // Masonry Grid Images
    if ( ts.classList.contains('vs-masonry-grid') ) {
      vndHlp.initSct(ts.id, null, vndMsrGrd.onLoad);
    }

    // Recently viewed products section
    if ( ts.classList.contains('vs-product-recent') ) {
      vndHlp.initSct(ts.id, null, vndPrdRcnt.onLoad);
    }

    // Product Page: template-product-layout section
    if ( ts.classList.contains('products-template') ) {
      vndHlp.initSct(ts.id, null, vndPrdTplSt.onLoad);
    }

    // Product Page: template-product-details-tabs section
    if ( ts.classList.contains('product-details-tabs') ) {
      vndHlp.initSct(ts.id, null, vndPrdDtTabsSt.onLoad);
    }

    // Product Page: data-driven products recommendation section
    if ( ts.classList.contains('vs-product-recommendations') ) {
      vndHlp.initSct(ts.id, null, vndPrdRecmd.onLoad);
    }

    // Collection Page
    if ( ts.classList.contains('collection-layout') ) {
      collectionPage.init();
    }

    // List collections Page
    if ( ts.classList.contains('list-collections') || ts.classList.contains('.sub-collection') ) {
      listCollectionsPage.init();
    }

    // Blog/Article Pages
    if ( ts.classList.contains('blog-section') ) {
      collectionPage.initSidebarMenu();
      vndHlp.initSct(ts.id, null, initSlider);
    }

    // Wishlist Page
    if ( ts.id == 'shopify-section-template-wishlist' ) {
      vndHlp.wslst();
    }

    // Compare Page
    if ( ts.id == 'shopify-section-template-compare' ) {
      vndHlp.cplst();
    }

    if ( typeof lazySizes !== 'undefined' ) {
      lazySizes.loader.checkElems();
    } else {
      imageLoad();
    }
  },

  onUnload(evt) {
    const ts = evt.target;
    if ( evt.detail.sectionId == 'header' ) {
      vndHeader.onUnload(evt);
    }

    if ( ts.classList.contains('vs-homepage-slideshow') ) {
      vndHlp.initSct(null, null, slideShow.onUnload);
    }
  },

  onSelect(evt) {
    const ts = evt.target;
    if ( ts.classList.contains('vs-group-content') ) {
      vndHlp.initSct(ts.id, null, groupContent.onLoad);
    }

    //Items carousel section
    if ( ts.classList.contains('vs-initialize-slider') ) {
      vndHlp.initSct(ts.id, null, vndSectionSlider.onLoad);
    }

    // Collection Page
    if ( ts.classList.contains('collection-layout') ) {
      collectionPage.init();
    }
  },

  onBlkSelect(evt) {
    const $tb = document.getElementById('shopify-section-' + evt.detail.sectionId); // Target Block

    if (evt.detail.sectionId == 'header') {
      vndHeader.onBlkSelect(evt);
    }

    if ( $tb.classList.contains('vs-homepage-slideshow') ) {
      slideShow.onBlkSelect(evt);
    }

    if ( $tb.classList.contains('vs-packery') ) {
      vndPkrSt.onBlkSelect(evt);
    }

    //Items carousel section
    if ( $tb.classList.contains('vs-initialize-slider') ) {
      vndSectionSlider.onBlkSelect(evt);
    }
  },

  onBlkDeselect(evt) {
    if (evt.detail.sectionId == 'header') {
      vndHeader.onBlkDeselect(evt);
    }
  }
}

// Map section
var mapSection = {
  onLoad(container) {
        if ( !container || container.classList.contains('map-loaded') ) return;
const markers=window.sucursales;
    let _map,flick;
    const waypoint = new Waypoint({
      element: container,
      offset: '120%',
      handler: function(direction) {
        container.classList.add('map-loaded');
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.src = "https://maps.googleapis.com/maps/api/js?key=" + vndTheme.gg_api_k +"&callback=gmap_draw";
        s.setAttribute('async', '');
        s.setAttribute('defer', '');
      
        window.gmap_draw = function() {
          _map=vndHlp.initMap('storeLocation',markers);
          if(_map){
            for(let i=0;i<markers.length;i++){
            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(markers[i].Ubicacion),
                map: _map,
              data:i,
                title: markers[i].Nombre,
                  icon:{
                          url: "https://cdn.shopify.com/s/files/1/0557/5966/7407/files/marker.png?v=1617405617",
                          size: new google.maps.Size(40, 51),
                          origin: new google.maps.Point(0, 0),
                          anchor: new google.maps.Point(20, 51),
                          scaledSize: new google.maps.Size(40, 51)
                      }

            });
              google.maps.event.addListener(marker, 'click', function (event) {
                const _carousel=$(flick).data('flickity');
                if(_carousel && _carousel.selectedIndex!= this.data){
                  _map.setZoom(17)
                  $(flick).flickity( 'select', this.data, true, true )
                  
                }
              })
            }
          }
        }
        
        $("head").append(s);
        waypoint.destroy();
      }
    });
      var $map = container.getElementsByClassName('main-carousel');
    if($map){
      flick= $($map).flickity({
          "cellAlign": "left",
        "wrapAround": true, 
        "contain": true ,
        "prevNextButtons": true,
        "pageDots": false,
          on: {
            select: function (index) {
              var flkty = this;
              if(_map){
                
              _map.setCenter(new google.maps.LatLng(markers[flkty.selectedIndex].Ubicacion));
                var w = window.innerWidth;

                if(w>992){
                let $form = $(`#storeLocation`).parent().find('.contact-on__map'),os_x;
              if ( $form.length > 0 ) {
                if ( $form.hasClass('form-center') ) {
                  os_x = (370 + $($form).find('.col-padding').width()) / 4;
                } else {
                  os_x = (370 * 0.1693 + $($form).find('.col-padding').width()) / 2;
                }

                _map.panBy(os_x, 0);
              }
                }
              }
            },
            
          }
        });
      
      //crear markers
      
      	
    }
    
  }
}

// Venedor helper
vndHlp.initMap = function (id,markers) {
  // Basic options for a simple Google Map
  // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
  let custom_styles = [{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#7f2200"},{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#87ae79"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#495421"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"},{"visibility":"on"},{"weight":4.1}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"saturation":"30"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4e4e4e"}]},{"featureType":"administrative.country","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"on"},{"saturation":"30"},{"color":"#4e4e4e"},{"weight":"1.50"}]},{"featureType":"administrative.province","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#2b2b2b"}]},{"featureType":"administrative.locality","elementType":"labels.text.stroke","stylers":[{"weight":"2.50"},{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"administrative.neighborhood","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#a4cd89"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#769E72"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#7B8758"},{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#EBF4A4"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"visibility":"off"},{"color":"#8dab68"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#5B5B3F"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ABCE83"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#EBF4A4"},{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#9BBF72"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#A4C67D"},{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#c5eaff"},{"visibility":"on"},{"weight":"1.00"}]},{"featureType":"water","elementType":"geometry.stroke","stylers":[{"visibility":"off"},{"color":"#ff0000"}]}];
  if ( vndTheme.map_style == '2' ) {
    custom_styles = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#212121"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#ffffff"},{"saturation":"0"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"lightness":"0"},{"gamma":"1"},{"weight":"0.80"},{"visibility":"simplified"},{"color":"#f1f1f1"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":"0"},{"visibility":"simplified"},{"color":"#3bb760"},{"gamma":"1"},{"weight":"1.90"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"lightness":"0"},{"saturation":"13"},{"visibility":"off"},{"hue":"#aaff00"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"0"},{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"},{"lightness":"-49"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"simplified"},{"lightness":"100"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"},{"saturation":"-24"},{"lightness":"-77"},{"weight":"2"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#f1f1f1"},{"visibility":"on"},{"lightness":"0"},{"gamma":"1"},{"weight":"1"}]}]
  } else if ( vndTheme.map_style == '3' ) {
    custom_styles = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#212121"},{"saturation":"0"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#ffffff"},{"saturation":"0"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"},{"lightness":"0"},{"gamma":"1"},{"weight":"0.80"},{"visibility":"simplified"},{"color":"#f1f1f1"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":"0"},{"visibility":"simplified"},{"color":"#f9ff50"},{"gamma":"1"},{"weight":"1.90"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"lightness":"0"},{"saturation":"13"},{"visibility":"off"},{"hue":"#aaff00"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"0"},{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"},{"lightness":"-49"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"simplified"},{"lightness":"100"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"},{"saturation":"-24"},{"lightness":"-77"},{"weight":"2"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#f1f1f1"},{"visibility":"on"},{"lightness":"0"},{"gamma":"1"},{"weight":"1"}]}]
  }
	
  const mapOptions = {
      // How zoomed in you want the map to start at (always required)
      zoom: 17,
    fullscreenControl:false,
    mapTypeControl:false,
    panControl :false,
    zoomControl :false,
      // The latitude and longitude to center the map (always required)
      // center: new google.maps.LatLng(40.6700, -73.9400), // New York
      center: new google.maps.LatLng(markers[0].Ubicacion),

      // How you would like to style the map.
      // This is where you would paste any style found on Snazzy Maps.
      //styles: custom_styles
  }

  // Get the HTML DOM element that will contain your map
  // We are using a div with id="map" seen below in the <body>
  const mapElement = document.getElementById(id);

  // Create the Google Map using our element and options defined above
  const map = new google.maps.Map(mapElement, mapOptions);
var w = window.innerWidth;
  if(w>992){
    let $form = $(`#${id}`).parent().find('.contact-on__map'),
      os_x;
  if ( $form.length > 0 ) {
    if ( $form.hasClass('form-center') ) {
      os_x = (370 + $($form).find('.col-padding').width()) / 4;
    } else {
      os_x = (370 * 0.1693 + $($form).find('.col-padding').width()) / 2;
    }

    map.panBy(os_x, 0);
  }
  }
  

  return map;
}

// Venedor Theme search functions
var vndSch = {
  init() {
    if ( vndHlp.isTchDvc() ) {
      $('.header-search .search-button').on('touchstart', function(e) {
        $p = $(e.target).parents('.search-form');
        if ( !$p.hasClass('js-hover') ) {
          if ( e.cancelable ) {
            e.preventDefault();
            e.stopPropagation();
          }
          $p.toggleClass('js-hover');
        }
      });
    }

    this.initPartialSearch();
    this.initBrandSearch();
  },

  initPartialSearch() {
    const $forms = document.getElementsByClassName('search-form');
    for (let i = 0; i < $forms.length; i++) {
      const $form = $forms[i];
      $form.addEventListener('submit', this.runSearch);
    }
  },

  initBrandSearch() {
    $('.vs-group-content .filter-list .nav-list__link').on('click', function(e) {
      e.preventDefault();
      vndHlp.setTagsFromString($(this).text());
      $(this).find('.ticksign').toggleClass('active');
    });

    $('.vs-group-content .search-with-brand').on('click', function(e) {
      e.preventDefault();
      vndHlp.setQueryParams();
      let params = '?' + jQuery.param(Shopify.queryParams).replace(/\+/g, '%20'),
          type = 'type=product',
          query = '&q=' + $(this).parent().find('.sidebar-search__input').val() + '*',
          targetUrl;

      if ( params.length > 1 ) {
        targetUrl = location.origin + location.pathname + 'search' + params + '&' + type + query;
      } else {
        targetUrl = location.origin + location.pathname + 'search?' + type + query;
      }

      window.history && window.history.pushState && window.history.pushState('','', targetUrl);
      location = targetUrl;
    });
  },

  initPredictive() {
    const _this = this,
          $inputs = document.querySelectorAll('.search-input-container input');
    for (let i = 0; i < $inputs.length; i++) {
      const $input = $inputs[i],
            $parent = $input.closest('.search-form'),
            $rs = $parent.querySelector('.result-container');

      if ( $rs ) {
        $input.addEventListener('input', function(e) {
          e.preventDefault();
          $parent.classList.add('js-hover')
          _this.setSearchResult(this, $rs);
        });
      }

      $input.onblur = function(e) {
        $parent.classList.remove('js-hover');
      };

      $input.onfocus = function(e) {
        $parent.classList.add('js-hover');
      };
    }
  },

  normalizeQuery(query) {
    if ( typeof query !== "string" ) {
      return null;
    }

    return query
      .trim()
      .replace(" ", "-")
      .toLowerCase();
  },

  setRequestParams(query) {
    return {
      "q": query,
      "resources": {
        "type": vndTheme.pdtv_fd || "product",
        "limit": vndTheme.sch_lmt || 5,
        "options": {
          "unavailable_products": "last"
        }
      }
    }
  },

  setSearchResult(crt, $rs) {
    const $this = crt,
          _this = this;

    let query = $this.value;

    if ( query == '' ) {
      $('.result-container').empty();
      return;
    }

    query = _this.normalizeQuery(query);
    if ( query ) {
      const params = _this.setRequestParams(query);

      jQuery.getJSON("/search/suggest.json", params)
        .done(function(response) {
          let products = response.resources.results.products,
              articles = response.resources.results.articles,
              pages = response.resources.results.pages,
              collections = response.resources.results.collections,
              $resultContainer = '',
              searchItem = '';

          if ( products.length > 0 ) {
            if ( vndTheme.pdtv_fd == 'product,page,article,collection' ) {
              $resultContainer += '<h2 class="search-category">' + vndTheme.lang.search.products + '</h2>';
            }

            $.each(products, function(index, product) {
              let productImg = '',
                  productPrice = '';
              if ( product.image ) {
                productImg = '<img class="lazyload" src="' + product.image + '" alt="'+ product.title +'"/>'
              }
              const productTitle = '<div class="product-info"><h3 class="product-name">' + product.title + '</h3>';
              if ( product.compare_at_price_max > 0 ) {
                productPrice = '<span class="old-price money">' + vndCurrency.formatMoney(product.compare_at_price_max, vndTheme.m_f) + '</span><span class="sale-price current-price money">' + vndCurrency.formatMoney(product.price, vndTheme.m_f) + '</span></div>';
              } else {
                productPrice = '<span class="sale-price current-price money">' + vndCurrency.formatMoney(product.price, vndTheme.m_f) + '</span></div>';
              }

              searchItem = '<a class="result-item ds-flex" href="' + product.url + '">' + productImg + productTitle + productPrice + '</a>';
              $resultContainer += searchItem;
            });
          }

          if ( vndTheme.pdtv_fd == 'product,page,article,collection' ) {
            if ( articles.length > 0 ) {
              $resultContainer += '<h2 class="search-category">' + vndTheme.lang.search.articles + '</h2>';

              $.each(articles, function(index, article) {
                let articleImg = '';
                if ( article.image ) {
                  articleImg = '<img class="lazyload" src="' + article.image + '" alt="'+ article.title +'"/>'
                }
                const articleTitle = '<h3 class="product-name">' + article.title + '</h3>';
                searchItem = '<a class="result-item ds-flex" href="' + article.url + '">' + articleImg + articleTitle + '</a>';
                $resultContainer += searchItem;
              });
            }

            if ( collections.length > 0 ) {
              $resultContainer += '<h2 class="search-category">' + vndTheme.lang.search.collections + '</h2>';
              $.each(collections, function(index, collection) {
                searchItem = '<a class="result-item ds-flex product-name" href="' + collection.url + '">' + collection.title + '</a>';
                $resultContainer += searchItem;
              });
            }

            if ( pages.length > 0 ) {
              $resultContainer += '<h2 class="search-category">' + vndTheme.lang.search.pages + '</h2>';
              $.each(pages, function(index, page) {
                searchItem = '<a class="result-item ds-flex product-name" href="' + page.url + '">' + page.title + '</a>';
                $resultContainer += searchItem;
              });
            }
          }

          $rs.innerHTML = $resultContainer;
      });
    }
  },

  runSearch(e) {
    e.preventDefault();
    let term = encodeURI(e.target.querySelector('.search-input-container input').value),
        searchPath = '/search',
        type = vndTheme.pdtv_fd || "product";
    if ( term.length > 0 ) {
      term += '*';
      searchPath += type == 'product' ? '?type=product&q=' + term : '?q=' + term;
    }
    location = location.origin + searchPath;

    e.target.removeEventListener('submit', this.runSearch);
  }
}

var vndLzHlp = {
  closePopups() {
    $(window).on('click touchstart', function(e) {
      // When user clicks outside of popup box, hide it
      if ( $('.vpp-bx.active').length
        && !$(e.target).hasClass('vpp-atv')
        && !$(e.target).parents('.vpp-atv').length
        && !$(e.target).hasClass('vpp-bx')
        && !$(e.target).parents('.vpp-bx.active').length ) {
          $('.vpp-bx.active').removeClass('active');
          document.dispatchEvent(vndTheme.events.popup_close);
      }

      if ( $('.dd-pp__wrp.active').length
        && !$(e.target).hasClass('dd-pp__wrp')
        && !$(e.target).parents('.dd-pp__wrp').length) {
        $('.dd-pp__wrp.active').removeClass('active');
      }

      if ( $('.cart-dropdown.active').length
        && !$(e.target).hasClass('cart-wrapper')
        && !$(e.target).parents('.cart-wrapper').length ) {
          $('.cart-dropdown.active').removeClass('active');
      }

      if ( $('.search-form.js-hover').length
        && !($(e.target).hasClass('search-form') && $(e.target).hasClass('js-hover'))
        && !$(e.target).parents('.search-form.js-hover').length ) {
          $('.search-form.js-hover').removeClass('js-hover');
      }
    });
  }
}

$(document).ready(() => {
  vndSch.init();
  vndLzHlp.closePopups();

  if ( vndTheme.sch_pdtv ) {
    vndSch.initPredictive();
  }

  var vndSts = new vndTheme.vndSts();
  vndHlp.initSct(null, 'section.vs-google-map', mapSection.onLoad);
});